import { createContext } from "react";

/**
 * CRM pages render inside a scrollable container owned by CrmLayout, not the window.
 * The layout publishes the element here — as state rather than a ref, so pages that
 * mount in the same commit as the layout re-render once it is attached — and list
 * pages save and restore their scroll position against it via useCrmScrollRestoration.
 */
export const CrmScrollContainerContext = createContext<HTMLElement | null>(null);
